import { NgxLoggerLevel } from 'ngx-logger';
import { Environment } from './environment.interface';

export const environment: Environment = {
  production: false,
  azure: {
    clientId: 'c672cc87-665d-4165-ad29-ec3e7afe8361',
    tenantId: 'f2baf195-6705-441b-912a-3b2997d976fd',
    redirectUri: 'https://portal.dev.onrsr.com.au',
  },
  logging: {
    level: NgxLoggerLevel.INFO,
    serverLogLevel: NgxLoggerLevel.WARN,
  },
  apiHost: 'api',  // Use relative URL for in-memory-web-api to intercept
  mapbox: {
    accessToken:
      'pk.eyJ1IjoiZHByaWRnZW9uLW9ucnNyIiwiYSI6ImNtcjJ5cnFuczBhbjkyenEydTJ5bzU5c2IifQ.U2sUv6g1wEa-1mEm9asHjg',
  },
};
